module.exports = __webpack_public_path__ + "static/media/group--general-cleanliness--dark.e5b6ed5c.svg";